import { Component, OnInit, Output, Input, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesStatus,MessagesDates } from '../../../../models/messages';

import {HttpErrorResponse } from '@angular/common/http';
import { DeudasService } from 'app/services/cobranzas/deudas/deudas.service';

import { AlertService } from 'app/services/alert.service';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "DD-MM-YYYY",
      monthYearA11yLabel: "MMMM YYYY"
    }
};

@Component({
    selector: 'app-registro-deudas',
    templateUrl: './registro-deudas.component.html',
    styleUrls: ['./registro-deudas.component.scss'],
    providers: [MessagesTitles,MessagesGeneral,MessagesStatus,MessagesDates,
      DatePipe,
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})

export class RegistroDeudasComponent implements OnInit, OnDestroy{

  @Output() refresh = new EventEmitter<boolean>();
  loading :boolean = false;
  save : boolean = false;  
  user:any;

  productosarr : any;
  flagCreateUpdate :boolean = false;
  titulo:string = "Crear nueva deuda";
  subtitulo: string = "";

  id;
  idCli ="" ;
  RUC_CLI : string;
  cliId = new FormControl();
  filteredCliente: Observable<any[]>;
  clientesArr;
  ruc = new FormControl();
  
  @Input() deuda : any;
  @Output() cerrarRegistroDeudas: EventEmitter<boolean>;

  formularioCrearDeuda : FormGroup;
  dataSource :any;
  monedaElement : string;

  productosSub: Subscription;
  deudaSub: Subscription;

  constructor(
              private DeudasService1:DeudasService,
              private msgStatus:MessagesStatus,
              private msgTitulos : MessagesTitles,
              private sweetAlertService: AlertService){
    this.ObtenerClienteCombo();
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.cerrarRegistroDeudas = new EventEmitter();
   


    this.formularioCrearDeuda = new FormGroup({
      "idDeuda": new FormControl(''),
      "idEmpresa": new FormControl(''),
      "Razon_Social": new FormControl(''),
      //"Fecha": new FormControl(''),
      "Codigo_Producto": new FormControl(''),
      "Descripcion": new FormControl(''),
      "Moneda": new FormControl(''),
      "Deuda_Importe": new FormControl(''),
      //"Alta_Fecha": new FormControl(''),
      //"Alta_Canal": new FormControl(''),
      "Alta_Usuario": new FormControl(this.user.Usuario),
    })

  }

  ngOnInit(){
    if(this.deuda){
      this.editarDeuda(this.deuda);
    } else {
      this.obtenerProductos();
    }
  }

  ngOnDestroy(): void {
    if(this.productosSub) this.productosSub.unsubscribe();
    if(this.deudaSub) this.deudaSub.unsubscribe();
  }

  tipoMoneda(event){
    this.formularioCrearDeuda.controls['Moneda'].setValue(event);
  }

  CerrarPopUp(){
    this.cerrarRegistroDeudas.emit();
    // this.refresh.emit()
  }

  obtenerProductos(){
    this.productosSub = this.DeudasService1.obtenerProductos().subscribe(res =>{
      this.productosarr = res;
    });
  }

  editarDeuda(element){
    this.flagCreateUpdate = true;
    this.productosarr = element.productos;
    this.titulo = "Editar Deuda";
    this.subtitulo =  "Nro "+element.idDeuda;
    this.cliId.setValue(element.Razon_Social);
    this.formularioCrearDeuda.controls['idDeuda'].setValue(element.idDeuda);
    this.formularioCrearDeuda.controls['idEmpresa'].setValue(element.idEmpresa);
    this.formularioCrearDeuda.controls['Moneda'].setValue(element.Moneda);
    this.formularioCrearDeuda.controls['Deuda_Importe'].setValue(element.Deuda_Importe);
    this.formularioCrearDeuda.controls['Codigo_Producto'].setValue(element.Codigo_Producto);
    this.formularioCrearDeuda.controls['Descripcion'].setValue(element.Descripcion);
    this.formularioCrearDeuda.controls['Alta_Usuario'].setValue(element.Alta_Usuario);
    this.monedaElement = element.Moneda;
  }
  setPrecio(evento){
    this.productosarr.forEach(element1 => {
      if(element1.idProducto == evento.value){
        this.formularioCrearDeuda.controls['Deuda_Importe'].setValue(element1.Precio);
      }
    });    
  }

  crearDeuda(){
    if(this.formularioCrearDeuda.invalid){
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "Complete los campos requeridos ",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
      return false;
    }

    this.loading = true;
    Swal.fire({
      title: "Espere",
      text: "Guardando Información",
      type: "info",
      allowOutsideClick: false
    });
    Swal.showLoading();

    if(this.flagCreateUpdate){
      this.deudaSub = this.DeudasService1.actualizarDeudas(this.formularioCrearDeuda.getRawValue()).subscribe(
        res => {
          this.loading = false;
          this.save = true;
          Swal.fire({
            title: "Éxito",
            text: "Deuda actualizada. " ,
            type: "success",
            allowOutsideClick: true
          });
          this.CerrarPopUp();
        },(err: HttpErrorResponse)=> {
          this.loading = false;
          this.msgStatus.getMessage(err.status);
          this.sweetAlertService.errorAlert("Deuda no actualizada. " + this.msgStatus.message);
        }
        )
    } else {
      this.deudaSub = this.DeudasService1.crearDeudas(this.formularioCrearDeuda.getRawValue()).subscribe(
        res => {
          this.loading = false;
          this.save = true;
          Swal.fire({
            title: "Éxito",
            text: "Deuda registrada. " ,
            type: "success",
            allowOutsideClick: true
          });
          this.CerrarPopUp();
        },(err: HttpErrorResponse)=> {
          this.loading = false;
          this.msgStatus.getMessage(err.status);
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "Deuda no actualizada. "+this.msgStatus.message ,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        }
      );
    }
  }
//   private _filterProv(value:string):any[]{
//     const filterValue = value.toString().toLowerCase();
//     return this.proveedoresArr.filter(state => state.Razon_Social.toLowerCase().includes(filterValue) === true);
//   }

//   ObtenerProveedorCombo(){
//     this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
//     this.filteredProveeedor = this.ruc.valueChanges
//     .pipe(
//         startWith(""),
//         map(state =>
//             state ? this._filterProv(state) : this.proveedoresArr.slice()
//         )
//     );
//   }
      
//   obtenerIdProv(termino:string){
//     //this.idProv = termino;
//     this.formularioCrearDeuda.controls['idProveedor'].setValue(termino);
//   }

//   EnteroObtenerRucRazSocialProv(termino:string = ''){
//     if(termino != null && termino != ''){
//       let termino1 = termino.toLowerCase();
//       for(let p of this.proveedoresArr){
//           let raz = p.Razon_Social.toLocaleLowerCase();
//         if(raz.indexOf(termino1) >=0){
//           //this.idProv = p.idEmpresa;
//           this.formularioCrearDeuda.controls['idProveedor'].setValue(p.idEmpresa);
//         }
//       }
//     }
//  }
EnterobtenerRucRazSocialCli(termino :string = ''){
  if (termino != null && termino != ''){
    let termino1 = termino.toLowerCase();                   
    for( let p of this.clientesArr){
        let raz = p.Razon_Social.toLocaleLowerCase();
      if (raz.indexOf(termino1)  >= 0){
          this.id = p.idEmpresa;
        }
    }
    this.formularioCrearDeuda.controls['idEmpresa'].setValue(this.id) 
  }
}

obtenerId(provId :string){
  this.formularioCrearDeuda.controls['idEmpresa'].setValue(provId) 
}

ObtenerClienteCombo() {
  this.clientesArr = JSON.parse(sessionStorage.getItem('lstCliCbo'));

    this.filteredCliente = this.cliId.valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterCli(state) : this.clientesArr.slice()
      )
    );
}

private _filterCli(value: string): any[] {
  const filterValue = value.toString().toLowerCase();

  return this.clientesArr.filter(
    state => state.Razon_Social.toLowerCase().includes(filterValue) === true
  );
}





    //this.formularioCrearDeuda.get('idDeuda').value
  
}